import React from 'react';
import { Printer } from 'lucide-react';
import { Button } from './ui/button';

const PrintButton = ({ title, content, image, excerpt }) => {
  const handlePrint = () => {
    // Create a new window for printing
    const printWindow = window.open('', '_blank');
    
    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>${title || 'Article'} - TruckAccidentSupport.com</title>
        <style>
          @page { margin: 0.5in; }
          * { box-sizing: border-box; margin: 0; padding: 0; }
          body {
            font-family: Georgia, 'Times New Roman', serif;
            line-height: 1.8;
            color: #000;
            padding: 20px;
          }
          .page-frame {
            border: 2px solid #d1d5db;
            border-radius: 12px;
            padding: 30px;
            position: relative;
            min-height: calc(100vh - 1in);
          }
          .corner-tl, .corner-tr, .corner-bl, .corner-br {
            position: absolute;
            width: 50px;
            height: 50px;
            border-color: #ea580c;
            border-style: solid;
          }
          .corner-tl { top: -2px; left: -2px; border-width: 4px 0 0 4px; border-radius: 12px 0 0 0; }
          .corner-tr { top: -2px; right: -2px; border-width: 4px 4px 0 0; border-radius: 0 12px 0 0; }
          .corner-bl { bottom: -2px; left: -2px; border-width: 0 0 4px 4px; border-radius: 0 0 0 12px; }
          .corner-br { bottom: -2px; right: -2px; border-width: 0 4px 4px 0; border-radius: 0 0 12px 0; }
          .logo-watermark {
            position: absolute;
            top: 15px;
            left: 20px;
            display: flex;
            align-items: center;
            gap: 8px;
            opacity: 0.2;
          }
          .logo-watermark svg { width: 24px; height: 24px; fill: #ea580c; }
          .logo-watermark span { font-size: 12px; font-weight: bold; color: #9ca3af; font-family: Arial, sans-serif; }
          .content-wrapper {
            margin-top: 30px;
          }
          h1 {
            font-size: 26px;
            font-weight: bold;
            margin-bottom: 16px;
            color: #1a1a1a;
            line-height: 1.3;
          }
          .excerpt {
            font-size: 15px;
            color: #555;
            font-style: italic;
            margin-bottom: 20px;
            padding-bottom: 16px;
            border-bottom: 1px solid #ddd;
          }
          .image-container {
            margin-bottom: 24px;
            text-align: center;
          }
          .image-container img {
            max-width: 100%;
            max-height: 300px;
            height: auto;
            border-radius: 8px;
            border: 1px solid #ddd;
          }
          .article-content {
            font-size: 14px;
            color: #1a1a1a;
          }
          .article-content p {
            margin-bottom: 14px;
          }
          .article-content strong, .article-content b {
            font-weight: bold;
          }
          .footer {
            margin-top: 30px;
            padding-top: 16px;
            border-top: 1px solid #ddd;
            text-align: center;
            font-family: Arial, sans-serif;
          }
          .footer-logo {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            margin-bottom: 8px;
          }
          .footer-logo svg { width: 20px; height: 20px; fill: #ea580c; }
          .footer-logo span { font-size: 13px; font-weight: bold; color: #333; }
          .footer-tagline { font-size: 11px; color: #ea580c; margin-bottom: 5px; }
          .footer-url { font-size: 10px; color: #666; }
          .footer-bottom {
            position: absolute;
            bottom: 12px;
            right: 18px;
            display: flex;
            align-items: center;
            gap: 6px;
            opacity: 0.15;
          }
          .footer-bottom svg { width: 18px; height: 18px; fill: #ea580c; }
          .footer-bottom span { font-size: 10px; color: #9ca3af; font-family: Arial, sans-serif; }
          @media print {
            body { padding: 0; }
            .page-frame { min-height: auto; border: 2px solid #d1d5db; }
          }
        </style>
      </head>
      <body>
        <div class="page-frame">
          <div class="corner-tl"></div>
          <div class="corner-tr"></div>
          <div class="corner-bl"></div>
          <div class="corner-br"></div>
          
          <div class="logo-watermark">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>
            <span>TruckAccidentSupport</span>
          </div>
          
          <div class="content-wrapper">
            <h1>${title || ''}</h1>
            ${excerpt ? `<p class="excerpt">${excerpt}</p>` : ''}
            ${image ? `<div class="image-container"><img src="${image}" alt="${title}" /></div>` : ''}
            <div class="article-content">${content?.replace(/\n/g, '<br/>') || ''}</div>
          </div>
          
          <div class="footer">
            <div class="footer-logo">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>
              <span>TruckAccidentSupport</span>
            </div>
            <p class="footer-tagline">Accident & Safety Resources</p>
            <p class="footer-url">truckaccidentsupport.com</p>
          </div>
          
          <div class="footer-bottom">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>
            <span>truckaccidentsupport.com</span>
          </div>
        </div>
      </body>
      </html>
    `;

    printWindow.document.write(printContent);
    printWindow.document.close();
    
    // Wait for images to load before printing
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    };
  };

  return (
    <Button
      variant="outline"
      size="sm"
      className="border-gray-700 hover:bg-gray-800 hover:border-orange-500 no-print"
      onClick={handlePrint}
      title="Print Article"
    >
      <Printer className="h-4 w-4 mr-2" />
      Print
    </Button>
  );
};

export default PrintButton;
